export default __webpack_public_path__ + "static/media/texture-sm.69a4537d.png";